import { combineReducers } from 'redux';
import _union from 'lodash/union';

const byId = (
  state = {
    isFetching: false,
    items: {},
  },
  action
) => {
  const _class = state.items[action.classId];
  switch (action.type) {
    case 'FETCH_CLASS_REQUEST':
    case 'FETCH_USERS_CLASSES_REQUEST':
      return {
        ...state,
        isFetching: true,
      };
    case 'FETCH_CLASS_SUCCESS':
    case 'FETCH_USERS_CLASSES_SUCCESS':
      return {
        ...state,
        isFetching: false,
        items: {
          ...state.items,
          ...action.response.entities.classes,
        },
      };
    case 'FETCH_CLASS_FAILURE':
    case 'FETCH_CLASS_DISABLED_MODULES_REQUEST':
      return {
        ...state,
        // isFetching: true,
      };
    case 'FETCH_CLASS_DISABLED_MODULES_SUCCESS':
      return {
        ...state,
        // isFetching: false,
        items: {
          ...state.items,
          [action.classId]: {
            ..._class,
            disabled_modules: action.response.results,
          },
        },
      };
    case 'FETCH_CLASS_DISABLED_MODULES_FAILURE':
      return {
        ...state,
        // isFetching: false,
      };
    case 'FETCH_USERS_CLASSES_FAILURE':
      return {
        ...state,
        isFetching: false,
      };
    case 'FETCH_STUDENTS_IN_CLASS_SUCCESS':
      return {
        ...state,
        items: {
          ...state.items,
          [action.classId]: {
            ..._class,
            student_ids: action.response.result,
          },
        },
      };
    case 'ADD_STUDENT_TO_CLASS':
      const newStudentOrder = [
        action.response.result[-1],
        ...action.response.result.slice(1),
      ];
      return {
        ...state,
        items: {
          ...state.items,
          [action.classId]: {
            ..._class,
            student_ids: newStudentOrder,
          },
        },
      };

    case 'POST_LOGOUT_SUCCESS':
    case 'CHANGE_ACTIVE_SCHOOL':
      return {
        ...state,
        items: {},
      };
    default:
      return state;
  }
};

const groupedByUserId = (state = {}, action) => {
  switch (action.type) {
    case 'POST_LOGOUT_SUCCESS':
    case 'CHANGE_ACTIVE_SCHOOL':
      return {};
    case 'FETCH_USERS_CLASSES_SUCCESS':
      const { classes } = action.response.entities;
      let mappedClasses = {};
      return {
        ...mappedClasses,
        [action.userId]: _union(
          mappedClasses[action.userId] || [],
          action.response.result
        ),
      };
    default:
      return state;
  }
};

const createClassStatus = (
  state = {
    isPosting: false,
    newClassId: null,
  },
  action
) => {
  switch (action.type) {
    case 'POST_CLASS_REQUEST':
      return {
        ...state,
        isPosting: true,
      };
    case 'POST_CLASS_FAILURE':
      return {
        ...state,
        isPosting: false,
      };
    case 'POST_CLASS_SUCCESS':
      return {
        ...state,
        isPosting: false,
        newClassId: action.id,
      };
    case 'CLEAR_NEW_CLASS_ID':
      return {
        ...state,
        newClassId: null,
      };
    default:
      return state;
  }
};

const classes = combineReducers({
  byId,
  groupedByUserId,
  createClassStatus,
});

export default classes;
export const getClass = (state, id) => state.byId.items[id];
export const getIsPostingClass = (state) => state.createClassStatus.isPosting;
export const getIsFetchingClasses = (state) => state.byId.isFetching;
export const getNewClassId = (state) => state.createClassStatus.newClassId;
